import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stunning%20editorial%20flat%20lay%20of%20diverse%20fashion%20products%20including%20colorful%20sneakers%2C%20a%20grey%20marl%20hoodie%2C%20white%20t-shirt%2C%20bucket%20hat%2C%20gold%20watch%20and%20leather%20backpack%20arranged%20on%20a%20soft%20sage%20green%20linen%20texture%20surface%2C%20bright%20natural%20window%20light%20from%20left%2C%20clean%20aesthetic%2C%20luxury%20product%20catalog%20style%2C%20high%20resolution%2C%20warm%20and%20fresh%20tones%20with%20sage%20green%20and%20warm%20beige%20palette&width=1920&height=1080&seq=kakobuy-hero-bg-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet produkty"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-32 md:py-40">
        <div className="max-w-3xl">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
            {t('hero.title')}
          </h1>
          <p className="text-base md:text-lg text-background-50/85 leading-relaxed mb-8 max-w-2xl">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-external-link-line"></i>
              {t('hero.cta_primary')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full border-2 border-background-50/60 text-background-50 font-medium text-sm md:text-base whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer"
            >
              {t('hero.cta_buy')}
            </a>
          </div>
        </div>

        <div className="mt-16 md:mt-20 flex flex-wrap gap-x-6 gap-y-3 max-w-2xl">
          {[
            { icon: 'ri-check-line', text: t('trust.updated') },
            { icon: 'ri-grid-line', text: t('trust.categories') },
            { icon: 'ri-book-open-line', text: t('trust.guides') },
            { icon: 'ri-shield-check-line', text: t('trust.safety') },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2.5 text-background-50/80 text-sm">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/15 flex-shrink-0">
                <i className={`${item.icon} text-sm text-background-50`}></i>
              </div>
              <span className="leading-snug">{item.text}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/15 cursor-pointer">
          <i className="ri-arrow-down-s-line text-background-50 text-xl"></i>
        </div>
      </div>
    </section>
  );
}